import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';

import Navbar from './pages/Navbar/Navbar';
import Works from './pages/Works/Works';
import WorkDetail from './pages/Works/components/WorkDetail';
import Lives from './pages/Lives/Lives';
import Contacts from './pages/Contacts/Contacts';
import Morse from './pages/Morse/Morse';
import Admin from './pages/Admin/Admin';
import SoundCloudHybridPlayer from './components/AudioPlayer/SoundCloudHybridPlayer';

import './fonts.css';
import './styles/main.css';

function AppContent() {
    const location = useLocation();
    const hidePlayer = location.pathname.startsWith('/admin');
    return (
        <div className="app-layout">
            <Navbar isNavbarVisible={true} />
            <main className="main-content">
                <Routes>
                    <Route path="/" element={<Works />} />
                    <Route path="/works" element={<Navigate to="/" replace />} />
					<Route path="/works/:slug" element={<WorkDetail />} />
                    <Route path="/live" element={<Lives />} />
                    <Route path="/about" element={<Contacts />} />
                    <Route path="/morse" element={<Morse />} />
                    <Route path="/admin/*" element={<Admin />} />
                </Routes>
            </main>
            {!hidePlayer && (
                <SoundCloudHybridPlayer playlistUrl="https://soundcloud.com/danzatribale/sets/losai-maitake" />
            )}
		</div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;